import { render, staticRenderFns } from "./AdminShopProducts.vue?vue&type=template&id=4396cadf&scoped=true&"
import script from "./AdminShopProducts.vue?vue&type=script&lang=js&"
export * from "./AdminShopProducts.vue?vue&type=script&lang=js&"
import style0 from "./AdminShopProducts.vue?vue&type=style&index=0&id=4396cadf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4396cadf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4396cadf')) {
      api.createRecord('4396cadf', component.options)
    } else {
      api.reload('4396cadf', component.options)
    }
    module.hot.accept("./AdminShopProducts.vue?vue&type=template&id=4396cadf&scoped=true&", function () {
      api.rerender('4396cadf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/AdminShopProducts.vue"
export default component.exports